<template>
  <div class="history">
    <div class="flex justify-between">
      <span class="text-font-1 text-14 font-semibold flex-y-center gap-[4px]">
        <iconpark-icon name="history" size="18" />{{ $t('sou-suo-li-shi') }}：
      </span>
      <iconpark-icon
        v-if="sortedHistory?.length"
        name="card-op-delete"
        class="cursor-pointer hover:text-primary"
        @click="emits('edit', { is_del: true })"
      ></iconpark-icon>
    </div>
    <div
      class="mt-[20px] flex gap-[12px] overflow-auto"
      :class="{
        'flex-wrap max-h-[85px]': direction === 'inline',
        'flex-col max-h-[400px]': direction === 'vertical',
      }"
    >
      <div v-if="!sortedHistory?.length" class="text-font-80 text-14">
        {{ $t('zan-wu-sou-suo-li-shi') }}
      </div>
      <div
        v-for="(item, index) in sortedHistory?.slice(
          0,
          historyLength ? historyLength : data.length,
        )"
        :key="index"
        class="truncate flex-shrink-0"
      >
        <div
          :title="item"
          class="tags truncate cursor-pointer"
          :class="{
            'max-w-[200px] ': size === 'large',
            'max-w-full': size !== 'large',
          }"
          @click="onSearch(item)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ClickType } from './constant';

const props = withDefaults(
  defineProps<{
    historyLength?: number;
    direction?: 'vertical' | 'inline';
    data: any[];
    size?: 'default' | 'large';
  }>(),
  {
    direction: 'inline',
    size: 'default',
  },
);

const emits = defineEmits(['search', 'edit']);

const sortedHistory = computed(() => {
  return props.data?.slice().reverse() || [];
});

const onSearch = (name: string) => {
  trackEvent(TRACK_EVENT.CLICK_SITE_SEARCH, {
    source: SOURCE.HELP_CENTER,
    keywords: name,
    click_type: ClickType['历史记录'],
  });
  emits('search', name);
};
</script>

<style scoped lang="scss">
.history {
  .tags {
    @apply rounded-[15px] inline-block bg-back-2 p-[6px_12px] text-16 text-font-80 hover:text-primary;
  }
}
</style>
